import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { STATUSES } from './keys';
import ManualClusterSelect from '../../../components/manualClusterModal';

class ExtraButtons extends Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;

        return (
            <div className="table-additional-view">
                <div className="table-additional-view-btns">
                    <div className="table-additional-view-btn-groups">
                        <button
                            className={`${(!this.props.view || this.props.view === 1) && 'active'}`}
                            onClick={() => this.props.onChange(1)}
                        >
                            {t('search.urls.extraButtons.view1')}
                        </button>
                        <button
                            className={`${this.props.view === 2 && 'active'}`}
                            onClick={() => this.props.onChange(2)}
                        >
                            {t('search.urls.extraButtons.view2')}
                        </button>
                    </div>
                    {this.props.view === 2 &&
                        STATUSES(t).map((item) => {
                            return (
                                <button
                                    className={`table-additional-view-btn ${
                                        this.props.status === item.value && 'active'
                                    }`}
                                    key={item.value}
                                    onClick={() => this.props.getData(item.value)}
                                    disabled={this.props.status === item.value}
                                >
                                    {item.label}
                                </button>
                            );
                        })}
                </div>
                <ManualClusterSelect
                    current_url={this.props.current_url}
                    csrf_token={this.props.csrf_token}
                    selectedItems={this.props.selectedItems}
                    cluster_type="url"
                    header={t('search.urls.extraButtons.addToUrlsList')}
                    onRemoveAllSelected={this.props.onRemoveAllSelected}
                />
            </div>
        );
    }
}

export default withTranslation()(ExtraButtons);
